import type { WordCollection } from "../collection.types";
import { createCollection } from "../logic";

const movementWordList = [
  "advance",
  "beat",
  "bend",
  "burst",
  "catch",
  "contract",
  "crash",
  "dive",
  "drop",
  "echo",
  "fall",
  "float",
  "flow",
  "fly",
  "gather",
  "hop",
  "jump",
  "leap",
  "lift",
  "pour",
  "pull",
  "push",
  "quake",
  "race",
  "release",
  "retreat",
  "rise",
  "roll",
  "rotate",
  "run",
  "rush",
  "sail",
  "shake",
  "slide",
  "spill",
  "spin",
  "spray",
  "start",
  "stop",
  "stream",
  "stretch",
  "swim",
  "swing",
  "throw",
  "turn",
  "twist",
  "walk",
];

export const movementCollection: WordCollection = createCollection(
  "movement",
  "Movement & Motion",
  movementWordList,
  { icon: "run", isWordlistViewable: true },
);
